import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section tone="cream" data-id="element-115" data-mp="2z5bcytzifl9f">
      <SectionTitle eyebrow="Answers" data-id="element-116" data-mp="3mstcxcsxhpnh">Frequently Asked Questions</SectionTitle>

      <div className="mt-7 space-y-3" data-id="element-117" data-mp="3mv5on883f3s3">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-white" data-id="element-118" data-mp="3d3rt1bj9io48" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-119" data-mp="3i09thz7k80ar">
                <span className="text-[14.5px] font-bold leading-snug text-navy" data-id="element-120" data-mp="20ri48muve0gx">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-121" data-mp="1vpj03arb2zix" />
              </button>
              <AnimatePresence initial={false} data-id="element-122" data-mp="2jgooiebbb04u">
                {isOpen ? <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-123" data-mp="2ei51sbow9kbf">
                    <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy/70" data-id="element-124" data-mp="2oh2qpfq8ffuy">
                      {faq.a}
                    </p>
                  </motion.div> : null}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <CTAButton className="mt-8" variant="navy" label="I'm ready — give me access" subline="Instant digital delivery" data-id="element-125" data-mp="1jrqmz2f00lji" />
    </Section>;
}